import useCalendarFiltersByDashboard from "./useCalendarFiltersByDashboard";

export default useCalendarFiltersByDashboard;
